module.exports = __webpack_public_path__ + "img/Fritzens.b495bb77.jpg";